var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ge_main"},[_c('img',{staticClass:"bg_img",attrs:{"src":"/static/hd/ganen/hd_bg_pc.jpg","alt":""}})])}]

export { render, staticRenderFns }